import { render, staticRenderFns } from "./batchad-filter.vue?vue&type=template&id=1f540e9d&scoped=true"
import script from "./batchad-filter.vue?vue&type=script&lang=js"
export * from "./batchad-filter.vue?vue&type=script&lang=js"
import style0 from "./batchad-filter.vue?vue&type=style&index=0&id=1f540e9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f540e9d",
  null
  
)

export default component.exports